import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
// import Button from '../../common/Button';

import profile0001 from '../../../images/profile_0001_without_dimension.png';
import profile0002 from '../../../images/profile_0002_without_dimension.png';
import profile0003 from '../../../images/profile_0003_without_dimension.png';
import profile0004 from '../../../images/profile_0004_without_dimension.png';
import profile0005 from '../../../images/profile_0005_without_dimension.png';
import profile0006 from '../../../images/profile_0006_without_dimension.png';
import profile0101 from '../../../images/profile_0101_without_dimension.png';
import Responsive from '../../common/Responsive';

const ProfileSelectionFormBlock = styled(Responsive)`
    .images {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .profile-image {
        width: 250px;
        padding: 0.5rem;
        margin: 0.5rem;
        margin-top: 1rem;
        background-color: ${palette.gray[0]};
        &:hover {
            background-color: ${palette.gray[1]};
        }
        // &:active {
        //     background-color: ${palette.gray[1]};
        // }
    }

    label {
        font-size: 1rem;
        font-weight: bold;
    }

    input {
        margin-right: 1rem;
    }

    .buttons {
        margin-top: 1rem;
        display: flex;
        justify-content: flex-end;
    }
`;

const Img = styled.div`
margin-top: 0.5rem;
    width: 100%;
    img {
        width: 100%;
    }
`;

// const StyledButton = styled(Button)`
//     height: 2rem;
//     & + & {
//         margin-left: 0.75rem;
//     }
// `;

const ProfileSelectionForm = ({ setImgNumber, onCancel, onConfirm }) => {
    return (
        <ProfileSelectionFormBlock>
            <div className="images">
                <div
                    className="profile-image"
                    onClick={(e) => setImgNumber('0001')}
                >
                    <label>
                        <input type="radio" name="profile" value="0001" />
                        Profile0001
                        <Img>
                            <img src={profile0001} alt="profile0001" />
                        </Img>
                    </label>
                </div>
                <div
                    className="profile-image"
                    onClick={(e) => setImgNumber('0002')}
                >
                    <label>
                        <input type="radio" name="profile" value="0002" />
                        Profile0002
                        <Img>
                            <img src={profile0002} alt="profile0002" />
                        </Img>
                    </label>
                </div>
                <div
                    className="profile-image"
                    onClick={(e) => setImgNumber('0003')}
                >
                    <label>
                        <input type="radio" name="profile" value="0003" />
                        Profile0003
                        <Img>
                            <img src={profile0003} alt="profile0003" />
                        </Img>
                    </label>
                </div>
                <div
                    className="profile-image"
                    onClick={(e) => setImgNumber('0004')}
                >
                    <label>
                        <input type="radio" name="profile" value="0004" />
                        Profile0004
                        <Img>
                            <img src={profile0004} alt="profile0004" />
                        </Img>
                    </label>
                </div>
                <div
                    className="profile-image"
                    onClick={(e) => setImgNumber('0005')}
                >
                    <label>
                        <input type="radio" name="profile" value="0005" />
                        Profile0005
                        <Img>
                            <img src={profile0005} alt="profile0005" />
                        </Img>
                    </label>
                </div>
                <div
                    className="profile-image"
                    onClick={(e) => setImgNumber('0006')}
                >
                    <label>
                        <input type="radio" name="profile" value="0006" />
                        Profile0006
                        <Img>
                            <img src={profile0006} alt="profile0006" />
                        </Img>
                    </label>
                </div>
                <div
                    className="profile-image"
                    onClick={(e) => setImgNumber('0101')}
                >
                    <label>
                        <input type="radio" name="profile" value="0101" />
                        Profile0101
                        <Img>
                            <img src={profile0101} alt="profile0101" />
                        </Img>
                    </label>
                </div>
            </div>
            {/* <div className="buttons">
                <StyledButton onClick={onCancel}>취소</StyledButton>
                <StyledButton cyan onClick={onConfirm}>
                    확인
                </StyledButton>
            </div> */}
        </ProfileSelectionFormBlock>
    );
};

export default ProfileSelectionForm;
